<template>
  <div id="app">
    <CHeader></CHeader>
    <div class="c-main">
      <router-view />
    </div>
    <CFooter></CFooter>
  </div>
</template>

<script>
import CFooter from "@/components/Footer/index.vue";
import CHeader from "@/components/Header/index.vue";

export default {
  components: {CHeader, CFooter},
  watch: {

  },
}
</script>

<style>
.c-main{
  min-height: calc(100vh - 410px);
}
</style>
